import * as React from 'react';
import { Formik } from 'formik';
import { Input } from './../Shared/BsInput';
import { Link } from 'react-router-dom';
import NoRecords from './../Shared/NoRecords';
import Pagination from './../Shared/Pagination';
import { Content } from 'src/models/content';
import { CONTENT_TYPES } from 'src/globals';

const ContentRow = (content: Content, index: number, onDelete: any) => {
  return (
    <tr key={index}>
      <td>{content.id}</td>
      <td>
        {
          content.ContentTranslations
            .find(t => t.language === 'es')!.title
        }
      </td>
      <td>
        {
          content.ContentTranslations
            .find(t => t.language === 'es')!.slug
        }
      </td>
      <td>{CONTENT_TYPES[content.type!]}</td>
      <td>
        <Link className="btn btn-dark btn-block btn-sm" to={`/editar/${content.id}`}>
          Editar
        </Link>
        <Link className="btn btn-primary btn-block btn-sm" to={`/modulos/${content.id}`}>
          Modulos
        </Link>
        <button
          className="btn btn-danger btn-block btn-sm"
          type="button"
          onClick={() => onDelete(content.id)}
        >
          Eliminar
        </button>
      </td>
    </tr>
  );
};

const ContentTable = (
  { contents, pages, onPageChange, onDelete }:
  { contents: Content[], pages: number, onPageChange: any, onDelete: any }
) => (
  <div>
    <Pagination pages={pages} onPageChange={onPageChange} />
    <table className="table table-bordered">
      <thead className="table-dark">
        <tr>
          <th>ID</th>
          <th>Titulo</th>
          <th>Slug</th>
          <th>Tipo</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {contents.map((c: Content, i: number) => ContentRow(c, i, onDelete))}
      </tbody>
    </table>
    <Pagination pages={pages} onPageChange={onPageChange} />
  </div>
);

const ContentList = (
  { contents, pages, onPageChange, onDelete }:
  { contents: Content[], pages: number, onPageChange: any, onDelete: any }
) => {
  return (
    <div className="card mb-5">
      <div className="card-header bg-primary text-white">
        <h3 className="mb-0">
          <i className="fa fa-file-text-o"></i> Contenidos
          <Link className="btn btn-light pull-right" to="/crear">
            <i className="fa fa-plus-circle"></i> Crear
          </Link>
        </h3>
      </div>
      <div className="card-body">
        <Formik
          initialValues={{ title: '' }}
          enableReinitialize={true}
          onSubmit={
            async (values: any, { setSubmitting, setErrors }: any) => {
              try {

                await onPageChange({ page: 1, where: { ...values } });
              } catch (err) {
                if (err.response.data.errors) {
                  setErrors(err.response.data.errors);
                }

                setSubmitting(false);
              }
            }
          }
          render={({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }: any) => {
            return (
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-md-4">
                    <Input
                      label="Titulo"
                      type="text"
                      name="title"
                      onChange={handleChange}
                      value={values.title}
                      errors={errors}
                    />
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Tipo</label>
                      <select
                        name="type"
                        onChange={handleChange}
                        className="form-control"
                        value={values.type}
                      >
                        <option value="">Indistinto</option>
                        {
                          Object.keys(CONTENT_TYPES).map((key: string, i: number) => {
                            return (
                              <option key={i} value={key}>{CONTENT_TYPES[key]}</option>
                            );
                          })
                        }
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group pt-3">
                      <button type="submit" className="btn btn-block btn-dark">
                        Filtrar
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        >
        </Formik>
        <hr/>
        {
          !contents || !contents.length
          ? <NoRecords />
          : <ContentTable {...{ contents, pages, onPageChange, onDelete }}/>
        }
      </div>
    </div>
  );
}

export default ContentList;



// WEBPACK FOOTER //
// ./src/components/Content/list.tsx